import React from "react";
import PropTypes from "prop-types";
import { Box } from "@material-ui/core";

// Both chips in the table were ~40 lines of nested ternaries inline.
// The colours live in one lookup now, so adding a status is one line.
const PAYMENT_COLORS = {
  PAID: { bg: "#e8f5e9", fg: "#2e7d32", label: "Paid" },
  PARTIAL: { bg: "#fff8e1", fg: "#f57f17", label: "Partial" },
  UNPAID: { bg: "#fff3e0", fg: "#ef6c00", label: "Unpaid" },
};

const STATUS_COLORS = {
  SENT: { bg: "#e8f5e9", fg: "#2e7d32", label: "Sent" },
  CANCELLED: { bg: "#ffebee", fg: "#c62828", label: "Cancelled" },
  DRAFT: { bg: "#fff3e0", fg: "#ef6c00", label: "Draft" },
};

const StatusChip = ({ kind, value, onClick }) => {
  const table = kind === "payment" ? PAYMENT_COLORS : STATUS_COLORS;
  const fallback = kind === "payment" ? "UNPAID" : "DRAFT";
  const key = String(value || fallback).toUpperCase();
  const style = table[key] || table[fallback];

  const chipStyle = {
    display: "inline-block",
    padding: "4px 10px",
    borderRadius: 20,
    backgroundColor: style.bg,
    color: style.fg,
    fontSize: 11,
    fontWeight: 600,
    minWidth: kind === "payment" ? 65 : 75,
    textAlign: "center",
  };

  if (!onClick) {
    return <Box style={chipStyle}>{style.label}</Box>;
  }

  return (
    <Box
      component="button"
      type="button"
      onClick={onClick}
      style={{
        ...chipStyle,
        cursor: "pointer",
        border: "none",
        outline: "none",
        fontFamily: "inherit",
      }}
    >
      {style.label}
    </Box>
  );
};

StatusChip.propTypes = {
  kind: PropTypes.oneOf(["payment", "status"]).isRequired,
  value: PropTypes.string,
  onClick: PropTypes.func,
};

export default StatusChip;
